import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
// import Model from './model';

// const model = new Model();

ReactDOM.render(
    <App />,
  document.getElementById('root')
);
